import { SkillType } from '../enums';

export interface VacancySkillModel {
  id: string;
  skill_id: string;
  type: SkillType;
  skill_name: string | null;
  skill_mapping_name: string | null;
  profession_id: string | null;
  rating: number | null;
  is_native: boolean | null;
}

export interface VacancyEducationLevelModel {
  id: string;
  name: string | null;
}
